"use strict";

var _classCallCheck = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddHeaderInterceptor = void 0;

var AddHeaderInterceptor = /*#__PURE__*/function () {
  function AddHeaderInterceptor(header, value) {
    _classCallCheck(this, AddHeaderInterceptor);

    this.header = header;
    this.value = value;
  }

  _createClass(AddHeaderInterceptor, [{
    key: "beforeSend",
    value: function beforeSend(request) {
      request.headers.set(this.header, this.value);
      return request;
    }
  }]);

  return AddHeaderInterceptor;
}();

exports.AddHeaderInterceptor = AddHeaderInterceptor;